import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Col, Container, Row } from 'react-bootstrap'
import EventCard from '../component/EventCard'
import ColorCalender from '../assets/images/calendar.png'
import LocationPin from '../assets/images/map-pin.png'
import Event from '../assets/images/events.png'
import OtherService from '../services/Other'
import ProfileService from '../services/Profile'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import Loader from '../component/Loader'
import NoData from '../component/NoData'
import { Empty } from "antd";
import DOMPurify from "dompurify";
import { parseSafeHtml } from "../utils/safeHtmlParser";

const NewsLetter = () => {
  //UseState
  const [isnewsLetter, setIsnewsLetter] = useState({ isnewsLetter: true })
  const [isHierarchiesId, setIsHierarchiesId] = useState('')
  const [isnewsLetterData, setIsnewsLetterData] = useState([])
  const [loading, setLoading] = useState(true);
  const [isNoData, setIsNoData] = useState(false)
   const [noData, setNoData] = useState(false);
  
  useEffect(() => {
    //HierarchiesId API
    const token = localStorage.getItem('access_token');
    ProfileService.getPersonalInfo(token)
      .then(res => {

        setIsHierarchiesId(res.response.Data.dcm_hierarchies_id)
        setLoading(false)
      }
      )
      .catch(error => {  })

    //News Letter API
    const payload = {
      "contentSpotCode": "newsletterMobileApp",
      "hierarchies": isHierarchiesId,
      "contactIds": []
    }
    OtherService.newsletter(payload, token)
      .then(res => {
        if (res.error == false && res.data.contentDetails.length > 0) {
          setIsnewsLetterData(res.data.contentDetails)
          setLoading(false)
          // setIsNoData(false);
          setNoData(false)
        }
        else {
          setLoading(false)
          // setIsNoData(true);
          setNoData(true)
        }

      })
      .catch(error => {
        
      })
  }, [])
  return (
    <>
      {loading && <Loader />}

      <BreadCrumbSecttion pageTitle="Newsletter" currentPageName="Newsletter" />
      <section className='padTop50'>
        <Container>
          <Row>
            <Col xs={12}>
            {/* {isNoData && <div className='noDataMsg'>No data found!</div>} */}
            {/* {noData && 
                    <Row>
                      <Col><NoData /></Col>
                    </Row>
            } */}
            {noData && <Empty
              // image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No records found"
              classNames={{root: "my-classname"}} styles={{root: {color: "red"}}}
            />           }
            </Col>
          </Row>
          {!isNoData &&
            <Row>

              {isnewsLetterData?.map((item) => {
                const { article_detail, thumbnail_image, file_path, id, files } = item;
                const handleDownload = () => {
                  const link = document.createElement('a');
                  link.href = files[0].file_path;
                  link.download = 'downloadedFile'; // Set the desired name for the downloaded file
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                return (
                  <Col xs={12} lg={4} key={id}>
                    <div className='upComingCard'>
                      <div className='upcomingImg'>
                        {files.length > 0 && (
                          <img src={files[0].thumbnail_image} alt='image' className='img-fluid' />
                        )}
                      </div>

                      <div className='upcomingEventDesc'>
                        {/* <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article_detail) }} className='mb-0'></p> */}
                        {/* <div className="mb-0"> */}
                          {parseSafeHtml(article_detail)}
                        {/* </div> */}

                      </div>

                      <div className='upComingEventBtnWrap'>

                        {/* <button onClick={handleDownload}>Test</button> */}
                        <PrimaryGradientButton buttonText="Download" onClick={handleDownload} />

                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          }
        </Container>
      </section>

    </>
  )
}

export default NewsLetter